module.exports = __webpack_public_path__ + "static/img/sjzl.d74ac12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/sjzl.png
// module id = f9yu
// module chunks = 0